module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gmaps",
    class: {
      loading: _vm.loading,
      failed: _vm.failed
    }
  }, [_vm._t("default", function() {
    return [_c('v-text-field', {
      staticClass: "input-group--focused",
      attrs: {
        "prepend-icon": "place",
        "hint": "Start typing an address and we'll search Google for places",
        "solo": "",
        "persistent-hint": "",
        "clearable": true,
        "type": "text",
        "id": _vm.id
      },
      on: {
        "focus": _vm.start
      },
      model: {
        value: (_vm.addressString),
        callback: function($$v) {
          _vm.addressString = $$v
        },
        expression: "addressString"
      }
    })]
  }), _vm._v(" "), (_vm.withSummary && _vm.location && _vm.location.adr_address) ? _c('v-card-text', [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.location.adr_address)
    }
  }), _vm._v(" "), _c('div', [_c('strong', [_vm._v("coordinates:")]), _vm._v(" "), (_vm.lat) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.lat)
    }
  }) : _vm._e(), _vm._v(",\n      "), (_vm.lng) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.lng)
    }
  }) : _vm._e()])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecfedaee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/AddressPicker.vue
// module id = 1545
// module chunks = 9